import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

export function SkeletonLoader(props: SkeletonProps) {
  return <Skeleton {...props} />;
}
